<template>
    <div :class="color ? 'not-fill' : 'fill'">
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8012 10.1426C10.9921 10.1426 11.183 10.2182 11.3315 10.3694L14.3315 13.425C14.6285 13.7275 14.6285 14.2028 14.3315 14.5053C14.0345 14.8078 13.5678 14.8078 13.2708 14.5053L10.2708 11.4497C9.97385 11.1473 9.97385 10.6719 10.2708 10.3694C10.4193 10.2182 10.6102 10.1426 10.8012 10.1426Z"
            :fill="color"
        />
        <path
            d="M4.91009 12.251C5.91833 12.6848 7.03072 12.8024 8.10492 12.5887C9.17912 12.3749 10.1663 11.8396 10.9401 11.0512C11.9715 10.0007 12.5509 8.57586 12.5509 7.0902C12.5509 5.60454 11.9715 4.17972 10.9401 3.12918C9.90865 2.07868 8.50974 1.48853 7.0511 1.48853C5.59245 1.48853 4.19354 2.07868 3.16209 3.12918C2.1307 4.17972 1.55127 5.60454 1.55127 7.0902C1.55127 8.57586 2.1307 10.0007 3.16209 11.0512C3.66263 11.5631 4.25638 11.9706 4.91009 12.251ZM8.6101 10.8445C7.63218 11.2647 6.53048 11.2723 5.54703 10.8657C4.56358 10.4591 3.7788 9.67157 3.36509 8.67603C2.95316 7.68024 2.94598 6.55865 3.34513 5.55747C3.74428 4.55629 4.51716 3.75732 5.4941 3.33594C6.47179 2.91637 7.57298 2.90906 8.55596 3.31561C9.53894 3.72215 10.3234 4.50934 10.7371 5.50437C11.149 6.50016 11.1562 7.62175 10.7571 8.62293C10.3579 9.62411 9.58503 10.4231 8.6081 10.8445H8.6101Z"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    </div>
</template>
<script>
export default {
    name: "Search",
    props: ["color"],
};
</script>
<style scoped>
svg {
    fill: var(--button-color);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/svg/components/Search.vue